<template >
  <div>
    <!-- 查询表单 start-->
    <div class="main_form">
      <el-form :inline="true" :model="queryModel" size="small" ref="queryForm">
        <el-form-item class="search_form_item" prop="status">
          <el-select v-model="queryModel.state" :placeholder="$t('m.audit_status')" clearable>
            <el-option :value="0" :label="$t('m.pending_review')"></el-option>
            <el-option :value="1" :label="$t('m.approved')"></el-option>
            <el-option :value="2" :label="$t('m.not_approved')"></el-option>
            <el-option :value="3" :label="$t('m.have-expired')"></el-option>
            <el-option :value="7" :label="$t('m.System_automatically_through')"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-col :span="11">
            <el-date-picker v-model="queryModel.createStartTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
              :placeholder="$t('m.apply_time')" style="width:100%"></el-date-picker>
          </el-col>
          <el-col class="coldiv" :span="1">~</el-col>
          <el-col :span="11">
            <el-date-picker v-model="queryModel.createEndTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
              :placeholder="$t('m.apply_time')" style="width:100%"></el-date-picker>
          </el-col>
        </el-form-item>
      </el-form>
      <!-- 按钮 -->
      <div class="btn-wrapper">
        <el-button @click="onQueryBtnClick" type="primary" size="small">{{ $t('m.search') }}</el-button>
        <el-button type="text" size="mini" @click="resetForm">{{ $t('m.reset') }}</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <div class="main_table">
      <el-table :data="tableData" border style="width: 100%;margin-bottom: 10px;" :row-class-name="tableRowClassName"
        v-loading="loading.table" ref="tableOrder" :element-loading-text="''" element-loading-spinner="el-icon-loading">
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column prop="userId" :label="$t('m.live_ID')"></el-table-column>
        <el-table-column prop="userNickName" :label="$t('m.sereamer_nickname')"></el-table-column>
        <el-table-column prop="reason" :label="$t('m.Transfer-grounds')"></el-table-column>
        <el-table-column prop="createTime" :label="$t('m.apply_time')"></el-table-column>
        <el-table-column prop="state" :label="$t('m.audit_status')">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">{{$t('m.pending_review')}}</span>
            <span v-else-if="scope.row.state == 1">{{$t('m.approved')}}</span>
            <span v-else-if="scope.row.state == 2">{{ $t('m.not_approved') }}</span>
            <span v-else-if="scope.row.state == 3">{{ $t('m.have-expired') }}</span>
            <span v-else-if="scope.row.state == 7">{{ $t('m.System_automatically_through') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="dealTime" :label="$t('m.approval-time')" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.dealTime">{{ scope.row.dealTime }}</span>
            <span v-else>---</span>
          </template>
        </el-table-column>
        <el-table-column prop="rejectReason" :label="$t('m.rejection_reason')">
          <template slot-scope="scope">
             <span v-if="scope.row.rejectReason">{{ scope.row.rejectReason }}</span>
             <span v-else>---</span>
          </template>
        </el-table-column>
        <el-table-column prop="useLang" :label="$t('m.mastery_lang')"></el-table-column>
        <el-table-column :label="$t('m.oper')" width="100">
          <template slot-scope="scope" v-if="scope.row.state === 0">
            <el-button type="text" @click="passApplication(scope.row)">{{ $t('m.pass') }}</el-button>
            <el-button type="text" @click="rejectCooperation(scope.row)">{{ $t('m.refused') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination @size-change="onSizeChange" @current-change="onCurrentPageChange" :current-page="queryModel.page"
        :page-sizes="[10, 20, 30, 100, 300, 500]" :page-size="queryModel.limit" small
        layout="total, sizes, prev, pager, next, jumper" :total="queryModel.total" :pager-count="5"></el-pagination>
    </div>
    <!-- 弹窗 -->
    <!-- <el-dialog :visible.sync="dialog.show" :title="$t('m.reject_streamer_join_agency_apply')"
      :close-on-click-modal="false" :append-to-body="true" @close="$refs.editForm.resetFields()">
      <el-form :model="dialog.model" :rules="dialog.rules" size="small" ref="editForm" label-position="left">
        <template>
          <div style="margin-bottom: 20px;">
            <el-button type="danger" style="padding:2px; margin-right: 5px;" icon="el-icon-close" circle></el-button>
            <span>{{ $t('m.reject_streamer_join_agency', { 'msg_ss1': dialog.model.userName, 'msg_ss2': guildName })
            }}</span>
          </div>
        </template>
        <el-form-item prop="refuseReason" :label="$t('m.rejection_reason') + ':'" label-width="100px">
          <el-input v-model.trim="dialog.model.refuseReason" type="textarea" :placeholder="$t('m.rejection_reason')"
            maxlength="50"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialog.show = false" size="small">{{ $t('m.cancel') }}</el-button>
        <el-button type="primary" @click="doEdit" size="small" :loading="dialog.btnLoading">{{ $t('m.Confirm')
        }}</el-button>
      </span>
    </el-dialog> -->
    <transfer-audit-dialog ref="transferAudit" @affirm="affirm"></transfer-audit-dialog>
  </div>
</template>
<script>
let queryModelEmpty = {
  state: null,
  createStartTime: null,
  createEndTime: null,
  page: 1,
  size: 10,
  total: 0
}
import {
  applyList,
  applyPass,
  applyReject
} from '../../api/anchor/management';
import { userLangArr, arrToString } from '../../utils/common';
import transferAuditDialog from './dialogs/transferAuditDialog.vue';
export default {
  components: {
    'transfer-audit-dialog':transferAuditDialog
  },
  inject: ['reload'],
  data() {
    return {
      searchBtnTrue: true, // 在生命周期中的列表数据加载完之前搜索按钮是不可点击状态
      guildList: [],
      videoState: false,
      n: 0,
      queryModel: JSON.parse(JSON.stringify(queryModelEmpty)),
      loading: {
        table: true
      },
      pager: {
        page: 1,
        limit: 10,
        total: 0
      },
      tableData: [],
      dialog: {
        rules: {
          refuseReason: [
            { required: true, trigger: 'change', message: this.$t('m.no_data') }
          ]
        },
        show: false,
        btnLoading: false,
        model: {
          id: null,
          userName: null,
          refuseReason: null,
          operation: 0
        },
        picture: {
          show: false,
          fileList: []
        },
      },
    }
  },
  filters: {
    // langFilt(val) {
    //   return arrToString(val);
    // }
  },
  computed: {
    guildName() {
      return (
        this.$store.state.userInfo.guildName
      );
    }
  },
  methods: {
    //重置参数
    resetForm() {
      this.queryModel = JSON.parse(JSON.stringify(queryModelEmpty));
    },
    tableRowClassName({ row, column, rowIndex }) {
      row.index = rowIndex;
    },

    //拒绝
    rejectCooperation(row) {
      this.$refs.transferAudit.init(row)
    },
    affirm(){
      this.getTableData();
    },
    // 通过
    passApplication(row) {
      this.$confirm(this.$t('m.agree_streamer_join_agency', { 'msg_ss1': row.userName, 'msg_ss2': this.guildName }), this.$t('m.pass_streamer_join_agency_apply'), {
        type: 'success'
      })
        .then(() => {
          applyPass({ id:row.id})
            .then(({ data }) => {
              this.getTableData();

            })
            .catch(() => { })
        })
        .catch(() => {

        })
    },

    onQueryBtnClick() {
      this.queryModel.page = 1;
      this.$refs.tableOrder.clearSort();
      this.query();
    },
    query() {
      this.loading.table = true;
      this.getTableData();
    },
    onSizeChange(size) {
      this.queryModel.size = size;
      this.query();
    },
    onCurrentPageChange(page) {
      this.queryModel.page = page;
      this.query();
    },
    getTableData() {
      // 显示表格loading
      this.loading.table = true;
      applyList(
        this.queryModel,
      ).then(({ data }) => {
        this.tableData = data.data.list;
        this.queryModel.total = data.data.total;
        // 取消loading状态
        this.loading.table = false;
        this.searchBtnTrue = false;
      })
        .catch(error => {
          this.loading.table = false;
        });
    },
  },
  created() {
    this.getTableData();
  }
}
</script>
<style lang="less">
.main_form {
  margin-bottom: 16px;
  padding: 16px;
  background-color: #FFFFFF;
}

.main_table {
  padding: 16px;
  background-color: #FFFFFF;
}

.el-tooltip__popper {
  max-width: 200px;
}

.el-carousel__container {
  position: relative;
  height: 500px;
}

@media screen and (max-width: 991px) {
  .el-carousel__container {
    position: relative;
    height: 400px;
  }
}

@media screen and (max-width:768px) {
  .el-carousel__container {
    position: relative;
    height: 300px;
  }
}
</style>
<style scoped>
.btn-wrapper {
  /* margin-bottom:20px; */
  min-height: 40px;
}

/* .btn_style {
    display: flex;
    justify-content: space-between;
    align-items: center;
  } */
.btn_style .el-button--small {
  padding: 20px 10px;
  font-size: 20px;
}

.btn_style .el-button--info {
  color: #909399;
  background-color: #fff;
  border-color: #fff;
}

.btn_style .el-button--info:hover {
  color: #909399;
  background-color: #e0e5ee;
  border-color: #e0e5ee;
}

.coldiv {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/anchor/transferAuditPage.vue